import { exigir } from './erros';

// Insert idempotente (decisão 117): o painel gera o id (uuid) antes de enviar e repete o MESMO id no "Tentar de
// novo". Se a 1ª resposta se perdeu com a linha já gravada, a 2ª tentativa bate na chave primária (23505) e a api
// relê pelo id e devolve a linha que já está lá, em vez de criar outra ou mostrar erro. Nunca é upsert: a linha
// que já existe não é sobrescrita. A releitura passa pelo RLS: id de outra loja não aparece e o erro original sai.

interface Resposta {
  data: unknown;
  error: unknown;
}

/** Violação de unicidade no PostgREST (chave primária ou outro índice único). */
export function ehChaveDuplicada(erro: unknown): boolean {
  return typeof erro === 'object' && erro !== null && (erro as { code?: unknown }).code === '23505';
}

/**
 * Devolve a linha inserida; se o insert bateu numa chave duplicada e `reler` acha a linha com o mesmo id (e da
 * mesma loja), devolve essa. Qualquer outro caso lança o erro do insert (ex.: telefone de outro cliente).
 */
export async function inserirOuReler<R extends Resposta>(
  resposta: R,
  reler: (() => Promise<NonNullable<R['data']> | null>) | null,
): Promise<NonNullable<R['data']>> {
  if (resposta.error && reler && ehChaveDuplicada(resposta.error)) {
    const jaEstava = await reler();
    if (jaEstava) return jaEstava;
  }
  return exigir(resposta);
}
